import React, { useEffect, useState } from "react";
import CompletedListCard from "./CompletedListCard";
import { Row, Col } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import PaginationComponent from "components/pagination/Pagination";
import { setCompletedRecentBooking } from "redux/actions/super-admin/CompletedRecentBookingsAction";
import pendingReq from "../../../../../assets/img/icons/customIcons/pending-req.svg";

function CompletedList({
  handleEmployeeSearchOnChange,
  handleSearch,
  searchFormData,
  setSearchFormData,
  data,
  companyId,
  toggle,
  list,
  handleClearDate,
}) {
  const dispatch = useDispatch();
  const [title, setTitle] = useState("");
  const [showToggle, setShowToggle] = useState(false);
  const fetchResultCompletedListRequests = useSelector(
    (state) => state.CompletedRecentBookingReducer.result
  );

  const fetchResultCompletedListRequestsLoader = useSelector(
    (state) => state.CompletedRecentBookingReducer.loader
  );

  useEffect(() => {
    setTitle(data);

    return null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const handlePagination = (tab) => {
    // setSearchFormData({
    //   ...searchFormData,
    //   page: tab,
    // })
    const finalData = {
      ...searchFormData,
      page: tab,
    };

    dispatch(
      setCompletedRecentBooking("1", "1", "completed", finalData, companyId)
    );
  };
  return (
    <>
      <Row className="mb-2">
        <Col md="12">
          <h3 className="tab-title">{`${title} (${
            fetchResultCompletedListRequests?.itemCount
              ? fetchResultCompletedListRequests?.itemCount
              : "0"
          })`}</h3>
        </Col>
        {/* <Col lg="7" md="12">
          <AnimatedSearchBar
            handleEmployeeSearchOnChange={handleEmployeeSearchOnChange}
            handleSearch={handleSearch}
          />
        </Col> */}
        <Col lg="5" md="12">
          <div className="common-outer-filter">
            {list && (
              <div className="btn-group new-cutom-filter ">
                <button
                  type="button"
                  onClick={() => setShowToggle(!showToggle)}
                  className={"btn dropdown-toggle mr-3"}
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <img alt="" src={pendingReq} width={"18px"} />
                </button>
                <div
                  className={`dropdown-menu dropdown-menu-right  ${
                    showToggle ? "show" : ""
                  }`}
                >
                  {list?.map((item, key) => (
                    <button
                      key={key}
                      className="dropdown-item"
                      onClick={() => toggle({ target: { value: item?.tabId } })}
                      type="button"
                    >
                      {item?.title}
                    </button>
                  ))}
                </div>
              </div>
            )}
            {/* <SearchDate
              handleEmployeeSearchOnChange={handleEmployeeSearchOnChange}
              handleSearch={handleSearch}
              clearDate={handleClearDate}
            /> */}
          </div>
        </Col>
      </Row>

      <CompletedListCard loader={fetchResultCompletedListRequestsLoader} />

      <div
        style={{
          display: fetchResultCompletedListRequestsLoader ? "none" : "contents",
        }}
      >
        <PaginationComponent
          totalCount={fetchResultCompletedListRequests?.itemCount}
          handlePagination={handlePagination}
          activePage={fetchResultCompletedListRequests?.activePage}
        />
      </div>
    </>
  );
}

export default CompletedList;
